
// const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
// const userToken = sessionStorage.getItem('student_token')
class fetchConfig {
    fetchConfigHeaders = () => {
        // const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        const userToken = sessionStorage.getItem('student_token')
        return ({
            'Authorization': userToken,
            'Access-Control-Allow-Origin': '*',
        })
    }
}
// let fetchConfig = {
//         'Content-Type': 'application/json;charset=UTF-8',
// 'Authorization': userToken,
// 'X-CSRF-Token': csrfToken
// };
export default fetchConfig;


// WEBPACK FOOTER //
// ./src/dashboards_redux/utils/fetchConfig.jsx